/* eslint-disable */
import React, { useContext } from 'react'
import { useParams } from 'react-router-dom'
import PlatformLayout from '../../components/PlatformLayout'
import { Paper } from '@mui/material'
import '../../globalStyle.scss'
import { useLocation } from 'react-router-dom'
import { OrgAppContext } from '../../OrgAppContext'
import { getProviderRole } from '../../utils/provider'
import ExceptionList from '../RulesSetting/ExceptionList'
import { useTranslation } from 'react-i18next'

function useQuery() {
  return new URLSearchParams(useLocation().search)
}

export default function EubaExceptions() {
  const { customerId } = useContext(OrgAppContext)
  const providerRole = getProviderRole(customerId)
  const { t } = useTranslation()

  const getRuleTitle = (type: string) => {
    return t(`alertType.${type}`, { providerRole })
  }

  let query = useQuery()
  let type = query.get('type')

  const { id } = useParams<{ id: string }>()
  const ruleId = id || ''

  return (
    <Paper
      square
      elevation={0}
      className='paperStyle'
      style={{
        display: 'flex',
        flexDirection: 'column',
        overflow: 'auto',
      }}
    >
      <div className='ruleSettingDetailsTitle'>{getRuleTitle(type as string)}</div>
      <Paper
        square
        elevation={0}
        style={{
          width: '100%',
          display: 'flex',
          flexDirection: 'column',
          height: 'calc(100vh - 212px)',
          overflow: 'auto',
        }}
      >
        <ExceptionList ruleId={ruleId} />
      </Paper>
    </Paper>
  )
}
